import React from "react";

const LeftPanelClose = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.548 12.0865V4.9135L8.952 8.5L12.548 12.0865ZM1.80775 17C1.30908 17 0.883083 16.8234 0.52975 16.4703C0.176583 16.1169 0 15.6909 0 15.1923V1.80775C0 1.30908 0.176583 0.883083 0.52975 0.52975C0.883083 0.176583 1.30908 0 1.80775 0H15.1923C15.6909 0 16.1169 0.176583 16.4703 0.52975C16.8234 0.883083 17 1.30908 17 1.80775V15.1923C17 15.6909 16.8234 16.1169 16.4703 16.4703C16.1169 16.8234 15.6909 17 15.1923 17H1.80775ZM4.5 15.5V1.5H1.80775C1.73075 1.5 1.66025 1.53208 1.59625 1.59625C1.53208 1.66025 1.5 1.73075 1.5 1.80775V15.1923C1.5 15.2692 1.53208 15.3398 1.59625 15.4038C1.66025 15.4679 1.73075 15.5 1.80775 15.5H4.5ZM6 15.5H15.1923C15.2692 15.5 15.3398 15.4679 15.4038 15.4038C15.4679 15.3398 15.5 15.2692 15.5 15.1923V1.80775C15.5 1.73075 15.4679 1.66025 15.4038 1.59625C15.3398 1.53208 15.2692 1.5 15.1923 1.5H6V15.5Z"
        fill="#71717A"
      />
    </svg>
  );
};

export default LeftPanelClose;
